__turbopack_context__.v({
  "className": "notosans_68137b00-module__MQG3XW__className",
});
